<template>
  <div>
    <div id="top-fixed-content" class="design">
      <app-header class="fix-position-box" id="layout-header"></app-header>
    </div>
    <div id="under-top-content">
      <router-view></router-view>
    </div>

    <spinner :show="loading">load</spinner>
  </div>
</template>

<script>
  import AppHeader from './simulator/AppHeader.vue'
  import Spinner from './simulator/Spinner.vue'

  export default {
    name: 'simulator',
    components: {
      AppHeader,
      Spinner,
    },
    props: {
      category_id: Number,
      figure_id: Number,
      design_id: Number,
    },
    data(){
      return {
        show: false,
        cw: null,
        flag: true,
        iw: null
      }
    },
    created () {
      const cart = JSON.parse(localStorage.getItem('cart'));
      if (cart) {
        this.$store.commit('setCartJson', cart);
      }
      const stock_cart = JSON.parse(localStorage.getItem('stock_cart'));
      if (stock_cart) {
        this.$store.commit('setStockCart', stock_cart);
      }

      // URL直入力
      if (this.design_id && (!cart || !cart.design || this.design_id !== cart.design.id)) {
        this.$store.commit('setLoading');
        window.axios.get('/designs/' + this.design_id + '.json').then(response => {
          this.$store.commit('setCartDesign', response.data.design);
          this.$store.commit('setCartParts', response.data.design.parts);
          this.$store.commit('resetLoading');
        });
        window.axios.get('/figures/' + this.figure_id + '.json').then(response => {
          this.$store.commit('setCartFigure', response.data.figure);
          this.$store.commit('resetLoading');
        });
        window.axios.get('/categories/' + this.category_id + '.json').then(response => {
          this.$store.commit('setCartCategory', response.data.category);
          this.$store.commit('resetLoading');
        });
        this.$store.commit('clearActiveTab');
        this.$store.commit('changeActiveTab', 2);
        this.$store.commit('disableAfterActiveTab', 3);
      } else if (this.figure_id && (!cart || !cart.figure || this.figure_id !== cart.figure.id)) {
        this.$store.commit('setLoading');
        window.axios.get('/figures/' + this.figure_id + '.json').then(response => {
          this.$store.commit('setCartFigure', response.data.figure);
          this.$store.commit('resetLoading');
        });
        window.axios.get('/categories/' + this.category_id + '.json').then(response => {
          this.$store.commit('setCartCategory', response.data.category);
          this.$store.commit('resetLoading');
        });
        this.$store.commit('clearActiveTab');
        this.$store.commit('changeActiveTab', 1);
        this.$store.commit('disableAfterActiveTab', 2);
      } else if (!cart || (!cart.category && this.category_id) || (this.category_id && this.category_id !== cart.category.id)){
        this.$store.commit('clearActiveTab');
        this.$store.commit('changeActiveTab', 0);
        this.$store.commit('disableAfterActiveTab', 1);
      }
      // @todo アイテム、タイプもキャッシュとURLが違う場合があるが問題ないと思われるので処理なし
    },
    computed: {
      page(){ return this.$store.state.page; },
      loading() {
        return this.$store.state.loading;
      },
    },
  }
</script>

<style>
  ul>li>button{
    margin: 7px 5px;
  }
  button
  {
    border: 1px solid #fff;
    border-radius: 4px;
    background-color: rgb(54,62,110);
    color: #fff;
    outline: 0;
    vertical-align: middle;
    cursor: pointer;
    text-align: center;
    display: inline-block;
    height: 35px;
    margin: 4px;
  }
  button.disabled
  {
    /*opacity: .2;*/
    color: rgb(72,92,146);
    border: 0;
  }
  .uk-button{
    color: #fff;
    border: 1px solid #fff;
    padding: 0 20px;
  }

  ul{
    margin: 0;
    padding: 0;
  }
  input[type="text"] {
    background: #eee;
    border: 1px solid #bebebe;
    font-size: 16px;
    text-indent: 0.7em;
  }

  input[type="text"]:focus {
    background: #edf4ff;
    border: 1px solid #4881d9;
  }

  select {
    border-radius: 0;
    border: 1px solid #bebebe;
    width: 150px;
    font-size: 16px;
    text-indent: 0.3em;
  }

  select:focus {
    border: 1px solid #4881d9;
    background: #edf4ff no-repeat;
    background-size: 10px 7px;
    background-position: right 10px center;
  }

  input, select{
    height: 35px;
    box-sizing: border-box;
  }

  .slide-fade-enter-active {
    transition: all .3s ease; }

  .slide-fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1); }

  .slide-fade-enter, .slide-fade-leave-to
  {
    transform: translateX(10px);
    opacity: 0; }

  .fade-enter-active {
    transition: opacity 0.5s;}

  .fade-leave-active{
    transition: opacity 0s;
  }
  .fade-enter, .fade-leave-to {
    position:absolute;
    opacity: 0; }

  .marquee {
    width:100%;
    padding:0.5em 0;
    overflow:hidden;
    background-color:#151d66;
    color: #fff;
    position:relative;
  }

  .marquee p:after {
    content:"";
    white-space:nowrap;
    padding-right:50px;
  }

  .marquee p {
    margin:0;
    padding-left:100%;
    display:inline-block;
    white-space:nowrap;
    -webkit-animation-name:marquee;
    -webkit-animation-timing-function:linear;
    -webkit-animation-duration:10s;
    -webkit-animation-iteration-count:infinite;
    -moz-animation-name:marquee;
    -moz-animation-timing-function:linear;
    -moz-animation-duration:10s;
    -moz-animation-iteration-count:infinite;
    -ms-animation-name:marquee;
    -ms-animation-timing-function:linear;
    -ms-animation-duration:10s;
    -ms-animation-iteration-count:infinite;
    -o-animation-name:marquee;
    -o-animation-timing-function:linear;
    -o-animation-duration:10s;
    -o-animation-iteration-count:infinite;
    animation-name:marquee;
    animation-timing-function:linear;
    animation-duration:10s;
    animation-iteration-count:infinite;
  }
  @-webkit-keyframes marquee {
    from   { -webkit-transform: translate(0%);}
    99%,to { -webkit-transform: translate(-100%);}
  }
  @-moz-keyframes marquee {
    from   { -moz-transform: translate(0%);}
    99%,to { -moz-transform: translate(-100%);}
  }
  @-ms-keyframes marquee {
    from   { -ms-transform: translate(0%);}
    99%,to { -ms-transform: translate(-100%);}
  }
  @-o-keyframes marquee {
    from   { -o-transform: translate(0%);}
    99%,to { -o-transform: translate(-100%);}
  }
  @keyframes marquee {
    from   { transform: translate(0%);}
    99%,to { transform: translate(-100%);}
  }
  .removefixed{
    border: 1px solid red;
    position: absolute;
  }
  .uk-modal.uk-open > .uk-modal-dialog{
    border-radius: 1em;
    background: rgba(255,255,255,0.9);
  }
  .uk-modal-header {
    text-align: center;
    background: #151d66;
    color: white;
    padding: 1em;
    border-radius: 1em;
  }
  .uk-modal-header h2{
    color: white;
  }
  .uk-modal-footer{
    text-align: center;
    background: transparent;
  }
</style>
<style scoped>
  #layout-header {
    touch-action: none;
  }
  #top-fixed-content{
    height: 43px;
    width: 100%;
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    background-color: #fff;
  }
  #under-top-content{
    padding: 48px 0 0 0;
  }
  #under-top-content.design{
    position: fixed;
    padding: 270px 0 0 0;
  }
  @media (min-width: 800px){
    #top-fixed-content.design{
    }
    #under-top-content.design{
      padding: 226px 0 0 0;
    }
  }
</style>
